import deathIcon from '../../../../assets/seguros-mobile/fallecimiento.svg'
import disabilityIcon from '../../../../assets/seguros-mobile/invalidez.svg'
import unemploymentIcon from '../../../../assets/seguros-mobile/desempleo.svg'
import damageIcon from '../../../../assets/seguros-mobile/danos.svg'
import processIcon from '../../../../assets/seguros-mobile/status.png'


export type InsuranceProcessCardData = {
  title: string
  iconSrc: string
  sections: Array<{
    title: string
    description?: string
    items?: string[]
  }>
}

export const requirements = [
  'Tu financiamiento se encuentre al corriente en sus pagos.',
  'La cobertura que deseas reclamar se encuentre contratada y vigente.',
  'La documentación de tu expediente esté completa.'
]

export const insuranceCoverageCards = [
  {
    titleOpen: 'Seguro de vida por fallecimiento',
    titleClosed: 'Seguro de vida por fallecimiento',
    description: 'Cuando ocurre el fallecimiento del titular o cotitular, los beneficiarios pueden iniciar la reclamación del seguro.',
    toggleLabel: 'Ver requisitos',
    iconSrc: deathIcon,
    details: [
      'Copia certificada del acta de defunción',
      'Copia simple del certificado de defunción',
      'Copia certificada del acta de nacimiento del asegurado y beneficiarios',
      'Identificación oficial del asegurado y beneficiarios',
      'Comprobante de domicilio del asegurado y beneficiarios',
      'Copia certificada del acta de matrimonio, cuando aplique',
      'Carta del tutor legal, cuando alguno de los beneficiarios sea menor de edad',
      'Actuaciones completas ante el Ministerio Público, en caso de muerte accidental ',
      'Reconocimiento del cuerpo',
      'Necropsia',
      ' Estudios toxicológicos ',
      ' Formato de reclamación ',
    ]
  },
  {
    titleOpen: 'Seguro por invalidez total y permanente',
    titleClosed: 'Invalidez total y permanente',
    description: 'Conoce los requisitos para solicitar la evaluación del seguro por invalidez.',
    toggleLabel: 'Ver requisitos',
    iconSrc: disabilityIcon,
    details: [
      'Debes contar con un empleo formal o con una causa de pérdida de empleo vigente.',
      'La documentación laboral y de identificación debe estar completa.',
      'La solicitud debe presentarse dentro de los plazos establecidos en la póliza.'
    ]
  },
  {
    titleOpen: 'Seguro por desempleo',
    titleClosed: 'Desempleo',
    description: 'Revisa las condiciones y documentos necesarios para iniciar una reclamación por desempleo.',
    toggleLabel: 'Ver requisitos',
    iconSrc: unemploymentIcon,
    details: [
      'Presenta el comprobante médico que acredite la incapacidad.',
      'Confirma que la cobertura esté activa y vigente en el periodo solicitado.',
      'Asegura que la información del solicitante sea correcta y completa.'
    ]
  },
  {
    titleOpen: 'Reporte de daños al inmueble',
    titleClosed: 'Daños al inmueble',
    description: 'Reporta los daños ocurridos en el inmueble asociado a tu financiamiento.',
    toggleLabel: 'Reportar daños',
    iconSrc: damageIcon,
    details: [
      'Se requiere la acta de defunción o constancia oficial.',
      'Debes contar con la información del contratante y beneficiarios.',
      'La documentación debe entregarse completa para iniciar la revisión.'
    ]
  }
]

export const insuranceProcessCards: InsuranceProcessCardData[] = [
  {
    title: 'Integrante',
    iconSrc: processIcon,
    sections: [
      {
        title: 'Fallecimiento o invalidez procedente',
        description: 'Los contratos se adjudican de forma directa y se entrega al titular o beneficiarios el monto adjudicado, descontando el CCI.'
      },
      {
        title: 'Fallecimiento o invalidez no procedente',
        description: 'El titular o los beneficiarios podrán optar por:',
        items: [
          'Cancelación sin pena convencional.',
          'Cesión de derechos sin costo.'
        ]
      },
      {
        title: 'Desempleo',
        description: 'Se notificará la procedencia o no de la reclamación.'
      }
    ]
  },
  {
    title: 'Adjudicatario',
    iconSrc: processIcon,
    sections: [
      {
        title: 'Fallecimiento o invalidez procedente',
        description: 'Se entrega al titular o beneficiarios el monto adjudicado, descontando el CCI.'
      },
      {
        title: 'Fallecimiento o invalidez no procedente',
        description: 'El titular o los beneficiarios podrán optar por:',
        items: [
          'Cancelación sin pena convencional.',
          'Cesión de derechos sin costo.'
        ]
      },
      {
        title: 'Desempleo',
        description: 'Se notificará la procedencia o no de la reclamación.'
      }
    ]
  },
  {
    title: 'Adjudicado',
    iconSrc: processIcon,
    sections: [
      {
        title: 'Fallecimiento o invalidez procedente',
        description: 'Se liquida el saldo insoluto del financiamiento y se emite la carta de liberación de hipoteca.'
      },
      {
        title: 'Fallecimiento o invalidez no procedente',
        description: 'Se mantiene la obligación de pago del titular o de los beneficiarios.'
      },
      {
        title: 'Desempleo procedente',
        description: 'La aseguradora podrá cubrir hasta tres cuotas mensuales, siempre que el asegurado continúe desempleado y se cumplan las condiciones de la póliza.'
      }
    ]
  }
]
